// // // import React from "react";

// // // const DotLoader = () => {
// // //   return (
// // //     <div>
// // //       <div className="loader"></div>
// // //     </div>
// // //   );
// // // };

// // // export default DotLoader;

// // import React, { useEffect, useRef, useState } from "react";
// // import { motion } from "framer-motion";

// // const DotLoader = () => {
// //   const containerRef = useRef(null);
// //   const [dotCount, setDotCount] = useState(5); // default value

// //   const DOT_SIZE = 12;
// //   const DOT_GAP = 12;

// //   // Measure the width of the parent and set the dot count
// //   useEffect(() => {
// //     const resize = () => {
// //       if (containerRef.current) {
// //         const width = containerRef.current.offsetWidth;
// //         const totalDotWidth = DOT_SIZE + DOT_GAP;
// //         const maxDots = Math.floor(width / totalDotWidth);
// //         setDotCount(maxDots > 2 ? maxDots : 3); // at least 3 dots
// //       }
// //     };

// //     resize();
// //     window.addEventListener("resize", resize);
// //     return () => window.removeEventListener("resize", resize);
// //   }, []);

// //   return (
// //     <div
// //       ref={containerRef}
// //       className="w-full flex justify-center items-center h-12"
// //     >
// //       <div className="flex gap-3">
// //         {Array.from({ length: dotCount }).map((_, i) => (
// //           <motion.div
// //             key={i}
// //             className="w-3 h-3 rounded-full bg-primary-500"
// //             animate={{
// //               scale: [1, 1.5, 1],
// //               opacity: [0.5, 1, 0.5],
// //             }}
// //             transition={{
// //               duration: 1,
// //               repeat: Infinity,
// //               delay: i * 0.1,
// //             }}
// //           />
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default DotLoader;

// // import React, { useEffect, useRef, useState } from "react";
// // import { motion } from "framer-motion";

// // const DotWaveLoader = () => {
// //   const containerRef = useRef(null);
// //   const [dotCount, setDotCount] = useState(50); // default

// //   const DOT_SIZE = 10;
// //   const DOT_GAP = 0;

// //   useEffect(() => {
// //     const updateDotCount = () => {
// //       if (containerRef.current) {
// //         const width = containerRef.current.offsetWidth;
// //         const totalDotWidth = DOT_SIZE + DOT_GAP;
// //         const maxDots = Math.floor(width / totalDotWidth);
// //         setDotCount(maxDots > 3 ? maxDots : 3);
// //       }
// //     };

// //     updateDotCount();
// //     window.addEventListener("resize", updateDotCount);
// //     return () => window.removeEventListener("resize", updateDotCount);
// //   }, []);

// //   return (
// //     <div
// //       ref={containerRef}
// //       className="w-full flex justify-center items-center h-12"
// //     >
// //       <div className="flex gap-2">
// //         {Array.from({ length: dotCount }).map((_, i) => (
// //           <motion.div
// //             key={i}
// //             className="w-[10px] h-[10px] rounded-full bg-primary-500"
// //             animate={{
// //               scale: [1, 1.8, 1],
// //               opacity: [0.4, 1, 0.4],
// //             }}
// //             transition={{
// //               duration: 2,
// //               repeat: Infinity,
// //               repeatType: "reverse",
// //               delay: i * 0.05, // wave effect
// //             }}
// //           />
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default DotWaveLoader;

// import React, { useEffect, useRef, useState } from "react";
// import { motion } from "framer-motion";

// const DotWaveLoader = () => {
//   const containerRef = useRef(null);
//   const [dotCount, setDotCount] = useState(50);

//   const DOT_SIZE = 10;
//   const DOT_GAP = 0;

//   useEffect(() => {
//     const updateDotCount = () => {
//       if (containerRef.current) {
//         const width = containerRef.current.offsetWidth;
//         const totalDotWidth = DOT_SIZE + DOT_GAP;
//         const maxDots = Math.floor(width / totalDotWidth);
//         setDotCount(maxDots > 3 ? maxDots : 3);
//       }
//     };

//     updateDotCount();
//     window.addEventListener("resize", updateDotCount);
//     return () => window.removeEventListener("resize", updateDotCount);
//   }, []);

//   const midpoint = dotCount / 2;

//   return (
//     <div
//       ref={containerRef}
//       className="w-full flex justify-center items-center h-12"
//     >
//       <div className="flex gap-[2px]">
//         {Array.from({ length: midpoint }).map((_, i) => (
//           <motion.div
//             key={i}
//             className="w-[10px] h-[10px] rounded-full bg-pink-600"
//             custom={i}
//             animate="pulse"
//             variants={{
//               pulse: (i) => ({
//                 scale: [1, 1.8, 1],
//                 opacity: [0.5, 1, 0.5],
//                 transition: {
//                   duration: 1.5,
//                   repeat: Infinity,
//                   repeatType: "loop",
//                   ease: "linear",
//                   delay: (i % dotCount) * 0.05,
//                 },
//               }),
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default DotWaveLoader;

import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const DotLoader = () => {
  const containerRef = useRef(null);
  const [dotCount, setDotCount] = useState(30);
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1); // 1 for left-to-right, -1 for right-to-left

  const DOT_SIZE = 12;
  const DOT_GAP = 10;

  //   useEffect(() => {
  //     const updateDotCount = () => {
  //       if (containerRef.current) {
  //         const width = containerRef.current.offsetWidth;
  //         const totalDotWidth = DOT_SIZE + DOT_GAP;
  //         const maxDots = Math.floor(width / totalDotWidth);
  //         setDotCount(maxDots > 5 ? maxDots : 5);
  //       }
  //     };

  //     updateDotCount();
  //     window.addEventListener("resize", updateDotCount);
  //     return () => window.removeEventListener("resize", updateDotCount);
  //   }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => {
        const next = prev + direction;
        if (next >= dotCount - 1 || next <= 0) {
          setDirection((d) => -d); // reverse direction
        }
        return next;
      });
    }, 40); // speed of transfer

    return () => clearInterval(interval);
  }, [dotCount, direction]);

  return (
    <div
      ref={containerRef}
      className="w-full flex justify-center items-center h-12"
    >
      <div className="flex gap-1.5">
        {Array.from({ length: dotCount }).map((_, i) => (
          <motion.div
            key={i}
            className={`w-[20px] h-[20px] rounded-full 
            ${i === activeIndex ? "bg-primary-500" : "bg-primary-500"}
                `}
            animate={{
              scale: i === activeIndex ? 4 : 0.6,
            }}
            transition={{ duration: 0.5 }}
          />
        ))}
      </div>
    </div>
  );
};

export default DotLoader;
